import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Panel, FormGroup, Button, Alert } from 'react-bootstrap';
import { Form } from 'formsy-react';
import { Input } from 'formsy-react-components';
import './styles/login.scss';


export default createReactClass({

   propTypes: {
      onLogin: PropTypes.func.isRequired,
      username: PropTypes.string,
      password: PropTypes.string,
      autologin: PropTypes.bool,
      passwordOnly: PropTypes.bool,
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
   },

   getDefaultProps() {
      return {
         username: '',
         password: '',
         message: '',
         autologin: false,
         passwordOnly: false,
      };
   },

   getInitialState() {
      return {
         canSubmit: false,
         showResetForm: false,
         message: this.props.message,
      };
   },

   componentWillMount() {
      const { autologin, username, password } = this.props;
      if (autologin && username && password) {
         this.login({ username, password });
      }
   },

   login({ username, password }) {
      this.setState({ isLoading: true });
      window.xnat.login(username, password)
         .then(() => this.props.onLogin(username, password))
         .catch((response) => {
            const text = response.status === 401
               ? 'Ihr Konto wurde anscheinend deaktiviert oder existiert nicht.'
               : response.statusText;
            this.setState({
               isLoading: false,
               message: {
                  header: 'Fehler beim Login',
                  text: text || 'unbekannt',
                  type: 'error',
               },
            });
         });
   },

   reset({ username }) {
      this.setState({ isLoading: true });
      window.xnat.reset(username).then(
         () => this.setState({
            isLoading: false,
            message: {
               header: 'Zurücksetzen des Passworts eingeleitet',
               text: 'Ein weiterführender Link wurde an Ihre E-Mail-Adresse geschickt.',
               type: 'success',
            },
         }),
         response => this.setState({
            isLoading: false,
            message: {
               header: 'Fehler beim Zurücksetzen',
               text: response.html.includes('User not found')
                  ? 'Benutzername nicht gefunden'
                  : response.statusText || 'unbekannt',
               type: 'error',
            },
         })
      );
   },

   getErrorMessage() {
      const message = this.getMessage();
      if (message) {
         if (message.type === 'error') {
            const header = <h4>{message.header || 'Fehler'}</h4>;
            return <Alert bsStyle="danger">{header}{message.text}</Alert>;
         }

         const header = message.header ? <h4>{message.header}</h4> : '';
         return <Alert bsStyle={message.type || 'info'}>{header}{message.text}</Alert>;
      }
      return '';
   },

   getMessage() {
      const message = this.state.message;

      if (!message) { return false; }

      if (_.isString(message)) {
         return {
            text: message,
            type: 'info',
         };
      }
      return message;
   },

   enableButton() {
      this.setState({ canSubmit: true });
   },

   disableButton() {
      this.setState({ canSubmit: false });
   },

   renderLoginForm() {
      const reset = () => this.setState({ showResetForm: true });
      return (
         <Panel header="Bitte Zugangsdaten eingeben">
            {this.getErrorMessage()}
            <Form onValidSubmit={this.login} onValid={this.enableButton} onInvalid={this.disableButton}>
               <FormGroup hidden={this.props.passwordOnly}>
                  <Input name="username" placeholder="Benutzername" layout="elementOnly" required value={this.props.username} />
               </FormGroup>
               <FormGroup>
                  <Input name="password" type="password" placeholder="Passwort" layout="elementOnly" required value={this.props.password} />
               </FormGroup>
               <div className="text-center">
                  <Button type="submit" disabled={!this.state.canSubmit}>Einloggen</Button>
               </div>
               <hr />
               <div className="text-center">
                  <Button bsStyle="link" onClick={reset}>Passwort vergessen?</Button>
               </div>
            </Form>
         </Panel>
      );
   },

   renderResetForm() {
      return (
         <Panel header="Passwort zurücksetzen">
            {this.getErrorMessage()}
            <Form onSubmit={this.reset}>
               <p>Bitte geben Sie Ihren Benutzernamen an. Wir schicken Ihnen dann eine E-Mail mit einem Link, über den Sie ein neues Passwort vergeben können. Der ganze Prozess dauert circa eine Minute.</p>
               <FormGroup>
                  <Input name="username" placeholder="Benutzername" layout="elementOnly" required value={this.props.username} />
               </FormGroup>
               <p className="text-center">
                  <Button type="submit">Passwort zurücksetzen</Button>
               </p>
               <p>
                  <small>P.S. Wir speichern keine Passwörter, nur kryptographische Ableitungen davon, weswegen wir Ihnen Ihr aktuelles Passwort nicht zuschicken können.</small>
               </p>
            </Form>
         </Panel>
      );
   },

   render() {
      if (this.state.isLoading) {
         return <h1 className="loading">Lade Benutzerdaten</h1>;
      }

      return (
         <div className="centered-panel">
            {
               this.state.showResetForm
                  ? this.renderResetForm()
                  : this.renderLoginForm()
            }
         </div>
      );
   },

});
